import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

interface SidebarProps {
  onViewReport: () => void;
  onViewData: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({  onViewData, onViewReport }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isDashboardActive = location.pathname === '/institutional-client-dashboard';
  const isViewDataActive = location.pathname.includes('/view-data');
  const isViewReportActive = location.pathname.includes('/view-report');

  const handleClientHome = () => {
    navigate("/institutional-client-dashboard");
  };

  const handleViewData = () => {
    navigate("/institutional-client-dashboard/view-data");
  };

  const handleViewReport = () => {
    navigate("/institutional-client-dashboard/view-report");
  };

  return (
    <aside className="fixed top-16 inset-y-0 left-0 z-40 hidden lg:block w-64  dark:bg-gray-800 dark:border-gray-700 overflow-y-auto">
      <div className="p-6">
        <nav className="space-y-1"> {/* Reduced space for tighter layout */}
          <button
            onClick={handleClientHome}
            className={`w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
              isDashboardActive
                ? "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 shadow-sm"
                : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            }`}
          >
            <svg className="h-5 w-5 mr-3 text-gray-400 dark:text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V7m-1 0V5a2 2 0 00-2-2H6a2 2 0 00-2 2v2m0 0V9a2 2 0 012-2h8a2 2 0 012 2v2m-4 0h4" />
            </svg>
            Dashboard
          </button>
          <button
            onClick={handleViewData}
            className={`w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
             isViewDataActive
                ? "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 shadow-sm"
                : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            }`}
          >
            <svg className="h-5 w-5 mr-3 text-gray-400 dark:text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-5.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
            </svg>
            Data
          </button>
          <button
            onClick={handleViewReport}
            className={`w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
              isViewReportActive
                ? "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 shadow-sm"
                : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            }`}
          >
            <svg className="h-5 w-5 mr-3 text-gray-400 dark:text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Report
          </button>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;